<template>
  <WCModal @dismiss="dismiss('Dismissed')" :aria-label="$t('alert')">
    <div class="text-right">
      <button
        class="btn btn-link underline-link-from-center text-right"
        @click="dismiss('Dismissed')"
      >
        {{ $t('close') }}
      </button>
    </div>
    <WCModalHeader class="border-secondary">
      <h1 class="font-size-lg">
        <b>{{ $t('waitItemsInCart') }}</b>
      </h1>
    </WCModalHeader>
    <WCModalBody>
      <div class="mb-2">
        <div class="pb-2">
          {{ $t('eGiftCardModalAlertText') }}
        </div>
      </div>
      <div class="mb-2">
        <b>{{ $t('youCanEither') }}:</b>
      </div>
      <div class="mb-2">{{ $t('removeItems') }}</div>
      <div class="mb-2">{{ $t('or') }}</div>
      <div class="mb-2">{{ $t('eGiftCardModalAlertShoppingText') }}</div>
      <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-primary col-12 mt-2" @click="dismiss('Dismissed')">
          {{ $t('okayGotIt') }}
        </button>
      </div>
    </WCModalBody>
  </WCModal>
</template>
<script>
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import ModalMixin from '@/modules/modals/mixins/ModalMixin';

export default {
  name: 'WCGiftCardPolicyModal',
  mixins: [ModalMixin],
  components: { WCModal, WCModalHeader, WCModalBody },
};
</script>
